<template>
  <div class="bp-form-inline form-check form-check-radio mt-1" :class="inlineClass">
    <label :for="cbId" class="form-check-label">
      <input :id="cbId"
             class="bp-form-radio form-check-input"
             type="radio"
             :disabled="disabled"
             :value="label"
             :checked="modelValue === label"
             @change="$emit('update:modelValue', label)"
      />
      <span class="form-check-sign">
      </span>
      <slot></slot>
    </label>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue'],
  name: 'l-radio',

  props: {
    label: [String, Number, Boolean],
    disabled: [Boolean, String],
    modelValue: [String, Number, Boolean],
    inline: Boolean
  },

  data () {
    return {
      cbId: ''
    }
  },

  computed: {
    inlineClass () {
      if (this.inline) {
        return `radio-inline`
      }
      return ''
    }
  },

  created () {
    this.cbId = Math.random().toString(16).slice(2)
  },
});
</script>
